<template>
  <div class="recupero-container">
    <Loader v-if="loading" />
    <div class="page-header">
      <h2>Recupero Switch-out</h2>
      <p>Gestione e ricontrattualizzazione clienti</p>
    </div>
    <div class="card">
      <div class="card-header">
        <h3>Ricerca Cliente</h3>
      </div>
      <div class="card-body">
        <div class="field">
          <label>Seleziona Codice fiscale o Partita Iva <span class="required">*</span></label>
          <SelectButton v-model="selected_option_cf_piva" :options="options_cf_piva"
            @update:modelValue="setSelectedTypeCf($event)" class="w-full" />
        </div>
        <div v-if="selected_option_cf_piva == 'Codice fiscale'" class="field">
          <label>Seleziona alfanumerico per domestico/ditta individuale o numerico per condominio <span
              class="required">*</span></label>
          <SelectButton v-model="selected_type_cf" :options="types_cf" @update:modelValue="setSelectedTypeCf($event)"
            class="w-full" />
        </div>

        <div class="field">
          <label>Inserisci {{ selected_option_cf_piva }} <span class="required">*</span></label>
          <div class="input-group">
            <InputMask v-if="selected_option_cf_piva == 'Partita Iva' || selected_type_cf == 'Numerico'"
              v-model="cf_piva" mask="99999999999" :unmask="true" placeholder="Inserisci 11 cifre" class="flex-1" />
            <InputMask v-else class="text_toupper flex-1" v-model="cf_piva" mask="aaaaaa99a99a999a" :unmask="true"
              placeholder="Inserisci codice fiscale" />
            <Button v-if="is_visible_search_btn" :label="`Ricerca ${selected_option_cf_piva}`" icon="pi pi-search"
              @click="searchSwo()" class="btn-primary" />
          </div>
        </div>

        <div v-if="agents.length" class="field">
          <label>Seleziona agente firmatario<span class="required">*</span></label>
          <Dropdown v-if="currentUser.role == 'admin'" v-model="selectedAgent" :options="agents" filter
            optionLabel="name" optionValue="id" placeholder="Seleziona un agente" class="w-full"
            @update:modelValue="onChangeAgent()" />
          <TreeSelect v-else v-model="selectedKeyAgent" :options="agents" filter optionLabel="name" optionValue="id"
            placeholder="Seleziona un agente" class="w-full" @node-select="onChangeAgent($event)" />
        </div>
      </div>
    </div>

    <div v-if="Object.keys(items).length && cf_piva != ''" class="card">
      <div class="card-header">
        <h4 class="m-0">Risultati per {{ cf_piva.toUpperCase() }}</h4>
        <br>
        <p>Seleziona un cliente e le forniture da ricontrattualizzare</p>
      </div>

      <div class="card-body">
        <div v-if="selected_id_client != null && has_selected_pp && selectedAgent != null" class="text-center m-4">
          <Button label="Contrattualizza" icon="pi pi-send" @click="openDialogConfirmContract()"
            class="btn-primary btn-lg" />
        </div>
        <div v-for="(cliente, id_cliente) of items" :key="id_cliente" class="client-section">

          <div class="client-info">
            <div class="client-select">
              <Checkbox v-model="cliente.selected" :binary="true"
                @update:modelValue="onSelectClient(id_cliente, cliente)" :disabled="!cliente.can_selected" />
              <div>
                <h4>{{ cliente.denominazione }}</h4>
                <p v-if="cliente.rappresentante_id">Rappresentante: {{ cliente.rappresentante }}</p>
              </div>
            </div>
          </div>

          <div class="supplies-grid">
            <div v-for="type_pp of getAvailableSupplyTypes(cliente)" :key="type_pp" class="supply-column">
              <h4 class="supply-type">{{ type_pp }}</h4>
              <div class="flex flex-wrap">
                <div v-for="pp of cliente[type_pp]" :key="pp.id_pp" class="supply-item col-12 md:col-6">
                  <div class="supply-header">
                    <Checkbox v-model="pp.selected" :binary="true" @update:modelValue="onSelectPP(type_pp, pp)"
                      :disabled="!pp.can_selected" />
                    <span class="supply-code">{{ pp.pp }}</span>
                  </div>
  
                  <div class="supply-details">
                    <span>Data fine: {{ moment(pp.data_fine).format('DD/MM/Y') }}</span>
                    <span class="saldo">Saldo: €{{ (pp.saldo).toFixed(2) }}</span>
                  </div>
  
                  <div v-if="pp.selected" class="supply-offer">
                    <Dropdown v-model="pp.selected_offerta" :options="offerte[type_pp]" optionLabel="name"
                      placeholder="Seleziona offerta" class="w-full" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog v-model:visible="visibleDialogConfirmContract" modal header="Conferma Contratto" class="contract-dialog"
      @hide="closeDialogConfirmContract()">

      <div class="dialog-content">
        <!-- Client Summary Card -->
        <div class="summary-card">
          <div class="summary-header">
            <i class="pi pi-user"></i>
            <h4>Informazioni Cliente</h4>
          </div>
          <div class="summary-body">
            <div class="info-row">
              <span class="label">Cliente:</span>
              <span class="value">{{ selected_client.denominazione }}</span>
            </div>
            <div v-if="selected_client.rappresentante_id" class="info-row">
              <span class="label">Rappresentante:</span>
              <span class="value">{{ selected_client.rappresentante }}</span>
            </div>
            <div class="info-row">
              <span class="label">Contatti:</span>
              <span class="value">{{ selected_client.contatto.email }} - {{ selected_client.contatto.cell }}</span>
            </div>
            <div class="info-row">
              <span class="label">Indirizzo:</span>
              <span class="value">{{ selected_client.contatto.toponimo }} {{ selected_client.contatto.indirizzo }}
                {{ selected_client.contatto.civico }} - {{ selected_client.contatto.comune }}</span>
            </div>
            <div class="info-row">
              <span class="label">Agente:</span>
              <span class="value highlight">{{ selectedAgentName }}</span>
            </div>
          </div>
        </div>

        <div class="summary-card">
          <div class="summary-header">
            <i class="pi pi-bolt"></i>
            <h4>Forniture Selezionate</h4>
          </div>
          <div class="summary-body">
            <div v-for="(pps, type) of getSelectedSupplies()" :key="type" class="supply-group">
              <div class="supply-type-badge">{{ type }}</div>
              <div class="supply-items">
                <div v-for="pp of pps" :key="pp.id_pp" class="supply-chip-modern">
                  <div class="chip-main">
                    <span class="chip-code">{{ pp.pp }}</span>
                    <span class="chip-offer">{{ pp.selected_offerta.name }}</span>
                  </div>
                  <i class="pi pi-check-circle chip-icon"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <Button label="Annulla" icon="pi pi-times" @click="closeDialogConfirmContract()" class="btn-cancel" />
          <Button label="Conferma Contratto" icon="pi pi-check" @click="sendContrattoRecovery()" class="btn-confirm" />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api';
import moment from 'moment'
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import { useStore } from 'vuex'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import Loader from "@/components/Loader.vue"
import { useToast } from 'primevue/usetoast';
import roles from '@/config/roles'
import { useRoute, useRouter } from 'vue-router'
import { useConfirm } from "primevue/useconfirm";
import TreeSelect from 'primevue/treeselect';

export default {
  components: { Loader, TreeSelect },
  setup(props, { emit }) {
    const toast = useToast();
    const store = useStore()
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const loading = ref(false)
    const currentUser = ref(store.state.auth.user)
    const items = ref({});

    const cf_piva = ref('')
    const selected_option_cf_piva = ref('Codice fiscale')
    const selected_type_cf = ref('Alfanumerico')
    const types_cf = ref(['Alfanumerico', 'Numerico'])
    const options_cf_piva = ref(['Codice fiscale', 'Partita Iva']);
    const types_pp = ref(['Pods', 'Pdrs'])

    const visibleDialogConfirmContract = ref(false)
    const selected_client = ref()
    const selected_id_client = ref()
    const selected_pp = ref({ Pods: [], Pdrs: [] })
    const agents = ref([])
    const selectedAgent = ref()
    const selectedAgentName = ref('')
    const selectedKeyAgent = ref()
    const offerte = ref({ 'Pods': [], 'Pdrs': [] })
    const selectedOfferte = ref([])

    const getAgents = async (id = null) => {
      if (id) {
        await service.getAgentAgency(id).then((res) => { agents.value = res.items })
      } else {
        service.getAgents().then((res) => { agents.value = res.items })
      }
    }

    const has_selected_pp = computed(() => {
      let selected_all_offerte = [];
      ['Pods', 'Pdrs'].forEach(type => {
        if (selected_pp.value[type].length > 0) {
          selected_pp.value[type].forEach(item => {
            selected_all_offerte.push(item.selected_offerta != null)
          })
        }
      })
      return (selected_pp.value.Pods.length > 0 || selected_pp.value.Pdrs.length > 0) && !(selected_all_offerte.some(el => !el))
    })

    const getAvailableSupplyTypes = (cliente) => {
      return types_pp.value.filter(type => type in cliente)
    }

    const getSelectedSupplies = () => {
      const filtered = {}
      Object.keys(selected_pp.value).forEach(type => {
        if (selected_pp.value[type].length > 0) {
          filtered[type] = selected_pp.value[type]
        }
      })
      return filtered
    }

    onMounted(() => {
      selected_option_cf_piva.value = 'Codice fiscale'
      selected_type_cf.value = 'Alfanumerico'
      let id_user = null
      if (currentUser.value.role == 'agent') {
        selectedKeyAgent.value = { 0: true }
        selectedAgent.value = currentUser.value.id
        id_user = currentUser.value.id
        getOfferteAgent()
      }
      Promise.all([getAgents(id_user)]).finally(() => { loading.value = false })
    })

    const closeDialogConfirmContract = () => {
      visibleDialogConfirmContract.value = false
      selected_client.value = null
      selected_id_client.value = null
      Object.keys(items.value).forEach(id_cliente => {
        items.value[id_cliente].can_selected = true
        items.value[id_cliente].selected = false
        types_pp.value.forEach(type => {
          if (type in items.value[id_cliente]) {
            items.value[id_cliente][type].forEach(pp => {
              pp.can_selected = false
              pp.selected = false
            })
          }
        })
      })
      selected_pp.value = { Pods: [], Pdrs: [] }
    }

    const setSelectedTypeCf = (evt) => {
      cf_piva.value = ''
      if (evt == 'Partita Iva') { selected_type_cf.value = 'Numerico' }
    }

    const onChangeAgent = (evt = null) => {
      if (evt) {
        selectedAgent.value = evt.id
        selectedAgentName.value = evt.name
      } else {
        let index_in_agents = agents.value.findIndex(agent => agent.id == selectedAgent.value)
        if (index_in_agents != -1) { selectedAgentName.value = agents.value[index_in_agents].name }
      }
      getOfferteAgent()
    }

    const getOfferteAgent = () => {
      service.getOfferteAgent(selectedAgent.value).then((res) => {
        [{ id: 1, type: 'Pods' }, { id: 2, type: 'Pdrs' }].forEach(el => {
          offerte.value[el.type] = []
          res.items.forEach(item => {
            if (el.id == item.tipologia) { offerte.value[el.type].push(item) }
          })
        })
      })
    }

    const is_visible_search_btn = computed(() => {
      let length = 0
      if (selected_option_cf_piva.value == 'Partita Iva' || selected_type_cf.value == 'Numerico') { length = 11 }
      if (selected_type_cf.value == 'Alfanumerico') { length = 16 }
      return cf_piva.value.length == length
    })

    const searchSwo = async () => {
      loading.value = true
      items.value = {}
      selected_client.value = null
      selected_id_client.value = null
      selected_pp.value = { Pods: [], Pdrs: [] }

      await service.searchSwo({ 'type': selected_option_cf_piva.value, 'cf_piva': (cf_piva.value).toUpperCase() })
        .then((res) => {
          if (res.items.success && Object.keys(res.items.items).length) {
            items.value = res.items.items
          } else {
            toast.add({ severity: 'warn', detail: res.items.msg });
            items.value = []
            cf_piva.value = ''
          }
        }).finally(() => { loading.value = false })
    }

    const onSelectClient = (id, cliente) => {
      if (selected_id_client.value == id) {
        selected_client.value = null
        selected_id_client.value = null
        Object.keys(items.value).forEach(id_cliente => {
          items.value[id_cliente].can_selected = true
          types_pp.value.forEach(type => {
            if (type in items.value[id_cliente]) {
              items.value[id_cliente][type].forEach(pp => {
                pp.can_selected = false
                pp.selected = false
              })
            }
          })
        })
        selected_pp.value = { Pods: [], Pdrs: [] }
      } else {
        selected_id_client.value = id
        selected_client.value = cliente
        Object.keys(items.value).forEach(id_cliente => {
          let new_can_selected = id == id_cliente
          items.value[id_cliente].can_selected = new_can_selected
          types_pp.value.forEach(type => {
            if (type in items.value[id_cliente]) {
              items.value[id_cliente][type].forEach(pp => pp.can_selected = new_can_selected)
            }
          })
        })
      }
    }

    const onSelectPP = (type, pp) => {
      let index_pp_in_selected = selected_pp.value[type].findIndex(el => el.id_pp == pp.id_pp)
      if (index_pp_in_selected == -1) {
        selected_pp.value[type].push(pp)
      } else {
        selected_pp.value[type].splice(index_pp_in_selected, 1)
        pp.selected_offerta = null
      }
    }

    const sendContrattoRecovery = async () => {
      loading.value = true
      await service.sendContrattoRecovery({
        'agente': selectedAgent.value,
        'pps': selected_pp.value,
        'cliente': selected_client.value,
        'cliente_id': selected_id_client.value,
      }).then((res) => {
        let severity = res.items.error ? 'error' : 'success'
        let summary = res.items.error ? 'Attenzione' : 'Successo'
        let detail = res.items.msg
        toast.add({ severity: severity, summary: summary, detail: detail });
      }).finally(() => {
        closeDialogConfirmContract()
        items.value = []
        cf_piva.value = ''
        selectedAgent.value = null
        selectedKeyAgent.value = null
        selectedAgentName.value = ''
        loading.value = false
      })
    }

    const checkSupply = async (obj) => {
      loading.value = true
      return service.checkSupply(obj).finally(() => { loading.value = false })
    }

    const openDialogConfirmContract = async () => {
      // let supply = { pod: [], pdr: [] }
      // Object.keys(selected_pp.value).forEach(type => {
      //   let type_pp = type == 'Pods' ? 'pod' : 'pdr'
      //   selected_pp.value[type].forEach(pp => supply[type_pp].push(pp.pp))
      // })
      // let existentSupply = await checkSupply(supply)
      // let array_existent_supply = []
      // Object.keys(existentSupply.items).forEach((supply) => {
      //   Object.keys(existentSupply.items[supply]).forEach((pp) => {
      //     let exist = existentSupply.items[supply][pp]
      //     if (exist) { array_existent_supply.push(pp) }
      //   })
      // })
      // if (array_existent_supply.length > 0) {
      //   toast.add({ severity: 'warn', detail: "Le seguenti forniture sono già state ricontrattualizzate: " + array_existent_supply.join(', ') })
      // } else {
      // }
      visibleDialogConfirmContract.value = true
    }

    return {
      selected_option_cf_piva, roles, currentUser, items, options_cf_piva, selected_type_cf,
      types_cf, cf_piva, is_visible_search_btn, searchSwo, setSelectedTypeCf, loading,
      types_pp, moment, onSelectClient, selected_client, selected_pp, onSelectPP,
      has_selected_pp, visibleDialogConfirmContract, selected_id_client, agents,
      selectedAgent, selectedKeyAgent, onChangeAgent, closeDialogConfirmContract,
      sendContrattoRecovery, offerte, selectedOfferte, selectedAgentName, openDialogConfirmContract,
      getAvailableSupplyTypes, getSelectedSupplies
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap');

.recupero-container {
  font-family: 'Montserrat', sans-serif;
  padding: 0;
  margin: 0;
  min-height: 100vh;
  width: 100%;
}

.page-header {
  margin: 0;
  background: white;
  padding: 2rem;
  border-bottom: 1px solid #e0e0e0;
}

.page-header h2 {
  font-size: 1.8rem;
  color: #000;
  margin: 0 0 0.5rem 0;
  font-weight: 600;
}

.page-header p {
  color: #666;
  margin: 0;
}

.card {
  background: white;
  border-radius: 0;
  box-shadow: none;
  margin: 0;
  border: none;
  border-bottom: 1px solid #e0e0e0;
}

.card-header {
  background: #215159;
  color: white;
  padding: 1.5rem 2rem;
  border-radius: 0;
  margin: 0 !important;
  border-bottom: none;
}

.card-header h3 {
  margin: 0;
  padding: 0;
}

.card-body {
  padding: 2rem;
  margin: 0;
}

.field {
  margin-bottom: 1.5rem;
}

.field label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #000;
}

.required {
  color: #e74c3c;
}

.input-group {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
}

.input-group .flex-1 {
  flex: 1;
}

.w-full {
  width: 100%;
}

.btn-primary {
  background: linear-gradient(135deg, #215159 0%, #2a6670 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-weight: 500;
  padding: 0.875rem 1.75rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(33, 81, 89, 0.2);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #1a444a 0%, #215159 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(33, 81, 89, 0.3);
}

.btn-secondary {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  border: none;
  border-radius: 12px;
  color: white;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.2);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.3);
}

.btn-lg {
  padding: 1.25rem 2.5rem;
  font-size: 1.1rem;
  border-radius: 16px;
}

.client-section {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 2rem;
}

.client-info {
  background: #f8f9fa;
  padding: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
}

.client-select {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.client-select h4 {
  margin: 0 0 0.5rem 0;
  font-weight: 600;
}

.client-select p {
  margin: 0;
  color: #666;
}

.supplies-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 1.5rem;
}

.supply-column {
  min-height: 200px;
}

.supply-type {
  color: #215159;
  font-weight: 600;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #215159;
}

.supply-item {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.supply-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.supply-code {
  font-weight: 600;
}

.supply-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.75rem;
}

.saldo {
  color: #28a745;
  font-weight: 500;
}

.supply-offer {
  border-top: 1px solid #e0e0e0;
  padding-top: 0.75rem;
}

/* Dialog Styles */
.contract-dialog {
  width: 90%;
  max-width: 700px;
}

.dialog-content {
  padding: 0;
}

.summary-card {
  background: white;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  margin-bottom: 1.5rem;
  overflow: hidden;
}

.summary-header {
  background: linear-gradient(135deg, #215159 0%, #2a6670 100%);
  color: white;
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.summary-header i {
  font-size: 1.2rem;
}

.summary-header h4 {
  margin: 0;
  font-weight: 500;
  font-size: 1.1rem;
}

.summary-body {
  padding: 1.5rem;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row .label {
  font-weight: 600;
  color: #666;
  min-width: 100px;
  flex-shrink: 0;
}

.info-row .value {
  color: #333;
  text-align: right;
  flex: 1;
}

.info-row .value.highlight {
  color: #215159;
  font-weight: 600;
}

.supply-group {
  margin-bottom: 1.5rem;
}

.supply-group:last-child {
  margin-bottom: 0;
}

.supply-type-badge {
  background: linear-gradient(135deg, #215159 0%, #2a6670 100%);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
  display: inline-block;
  margin-bottom: 1rem;
}

.supply-items {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.supply-chip-modern {
  background: #f8f9fa;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.supply-chip-modern:hover {
  border-color: #215159;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(33, 81, 89, 0.1);
}

.chip-main {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.chip-code {
  font-weight: 600;
  color: #333;
  font-size: 1rem;
}

.chip-offer {
  color: #666;
  font-size: 0.9rem;
}

.chip-icon {
  color: #28a745;
  font-size: 1.5rem;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem 0 0 0;
  border-top: 1px solid #e0e0e0;
}

.btn-cancel {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-weight: 500;
  padding: 1rem 2rem;
  min-width: 180px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.2);
}

.btn-cancel:hover {
  background: linear-gradient(135deg, #5a6268 0%, #343a40 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.3);
}

.btn-confirm {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-weight: 500;
  padding: 1rem 2rem;
  min-width: 180px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.2);
}

.btn-confirm:hover {
  background: linear-gradient(135deg, #218838 0%, #1ba085 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.3);
}

.text-center {
  text-align: center;
}

.mt-4 {
  margin-top: 2rem;
}

.text_toupper {
  text-transform: uppercase;
}

.recupero-container .card:first-of-type {
  margin-top: 0;
}

.recupero-container .card:last-of-type {
  margin-bottom: 0;
}

:deep(.p-selectbutton .p-button) {
  background: white;
  border: 2px solid #e0e0e0;
  color: #495057;
  transition: all 0.3s ease;
  border-radius: 12px;
  font-weight: 500;
  padding: 0.75rem 1.5rem;
}

:deep(.p-selectbutton .p-button.p-highlight) {
  background: linear-gradient(135deg, #215159 0%, #2a6670 100%);
  border-color: #215159;
  color: white;
  box-shadow: 0 4px 15px rgba(33, 81, 89, 0.2);
}

:deep(.p-selectbutton .p-button:hover) {
  border-color: #215159;
  transform: translateY(-1px);
}

:deep(.p-inputtext),
:deep(.p-dropdown) {
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 0.875rem 1rem;
  transition: all 0.3s ease;
  font-weight: 400;
}

:deep(.p-inputmask) {
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 0.875rem 1rem;
  transition: all 0.3s ease;
  font-weight: 400;
}

:deep(.p-dropdown) {
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 0.875rem 1rem;
  transition: all 0.3s ease;
  font-weight: 400;
}

:deep(.p-treeselect) {
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 0.875rem 1rem;
  transition: all 0.3s ease;
  font-weight: 400;
}

:deep(.p-inputtext:focus),
:deep(.p-dropdown:focus) {
  border-color: #215159;
  box-shadow: 0 0 0 0.25rem rgba(33, 81, 89, 0.1);
  transform: translateY(-1px);
}

:deep(.p-checkbox .p-checkbox-box) {
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  width: 1.5rem;
  height: 1.5rem;
  transition: all 0.3s ease;
}

:deep(.p-checkbox .p-checkbox-box.p-highlight) {
  background: linear-gradient(135deg, #215159 0%, #2a6670 100%);
  border-color: #215159;
  box-shadow: 0 4px 15px rgba(33, 81, 89, 0.2);
}

:deep(.p-dialog .p-dialog-header) {
  background: linear-gradient(135deg, #215159 0%, #2a6670 100%);
  border-radius: 16px 16px 0 0;
  padding: 1.5rem;
}

:deep(.p-dialog .p-dialog-content) {
  border-radius: 0 0 16px 16px;
  padding: 1.5rem;
}

:deep(.p-dialog .p-dialog-footer) {
  padding: 0 1.5rem 1.5rem 1.5rem;
  border-top: none;
}

@media (max-width: 768px) {
  .page-header {
    padding: 1rem;
  }

  .card-header {
    padding: 1rem;
  }

  .card-body {
    padding: 1rem;
  }

  .client-info {
    padding: 1rem;
  }

  .supplies-grid {
    grid-template-columns: 1fr;
    padding: 1rem;
  }

  .input-group {
    flex-direction: column;
  }

  :deep(.p-inputtext),
  :deep(.p-dropdown),
  :deep(.p-inputmask),
  :deep(.p-treeselect) {
    width: 100%;
  }

  .input-group .flex-1 {
    flex: 1;
  }
}
</style>